import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { resetAll } from 'actions/app';
import { resetUserErrors } from 'actions/user';
import api from 'api/user';
import { RootState } from 'store';
import { PageAuthWrapperLegacy } from '../components/PageAuthWrapperLegacy';
import { LoginFormLegacy } from './LoginFormLegacy';
import { PageAuthWrapper } from '../components/PageAuthWrapper';
import { LoginForm } from './LoginForm';
import { ComponentRegistry } from 'runtime/registry/components/ComponentRegistry';
import { activeWlConfigStore } from 'config/wls/wlConfig';


const LoginPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const config = activeWlConfigStore.getActiveWlConfig()

  const [isLoading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    email: '',
    password: '',
  });
  const {
    user,
    settings: { isSignUpAvailable, wl, wlId },
  } = useSelector((state: RootState) => state);
  const { email, password } = formValues;
  const domain = wlId && config?.isInternalSignup ? '' : `https://${wl}.com`;
  const signUpLink = isSignUpAvailable ? (domain + '/sign-up') : '';

  const props = ComponentRegistry.getProps('LoginPage')

  useEffect(() => {
    dispatch(resetUserErrors());
    dispatch(resetAll());
  }, []);

  const navigateToResetPassword = () => {
    history.push('/reset-password');
  };

  const handleChangeValues = (key: string, value: string) => {
    setFormValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleLogin = async () => {
    setLoading(true);

    try {
      await api.login({
        email: email.trim(),
        password,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return wlId === 1 ? (
    <PageAuthWrapper>
      <LoginForm
        signUpLink={signUpLink}
        validation={user && user.validationErrors}
        email={email}
        password={password}
        isLoading={isLoading}
        onChange={handleChangeValues}
        onLogin={handleLogin}
        goToResetPassword={navigateToResetPassword}
      />
    </PageAuthWrapper>
  ) : (
    <PageAuthWrapperLegacy title="auth.login.header" layout={props?.layout}>
      <LoginFormLegacy
        signUpLink={signUpLink}
        isInternalSignup={config?.isInternalSignup}
        validation={user && user.validationErrors}
        email={email}
        password={password}
        isLoading={isLoading}
        onChange={handleChangeValues}
        onLogin={handleLogin}
        goToResetPassword={navigateToResetPassword}
        wlId={wlId}
      />
    </PageAuthWrapperLegacy>
  );
};

export default LoginPage;